import { SafeUrl } from "@angular/platform-browser";

export interface MediaViewModel {
    id: number,
    type: string,
    preview: string,
    fullsize: string,
    saveIn: number
    from?: string
    source?: any;
    frameurl?: SafeUrl
    asset_id?: any;
    isActive?:boolean
    url?:any;
    aspect_ratio?:any;
    thumbnail_url?:any;
}

export class MediaViewModel {
    constructor(init?: Partial<MediaViewModel>) {
        Object.assign(this, init);
    }
}